import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class CountryService {
  static ENDPOINT = `${BASE}/country`;

  static async getAll() {
    return await request({
      url: `${this.ENDPOINT}/`,
      auth: false
    })    
  }

  static async get(id) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(id)}`,
      headers: {'Accept': 'application/json'}
    })
  }
}

export default CountryService;
